import { useNavigation } from "@react-navigation/native";
import { Check } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { YStack } from "tamagui";
import { Body } from "../../../ui/Body";
import { Box } from "../../../ui/Box";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/InputNew";
import { Pill, PillType } from "../../../ui/Pill";
import { Title } from "../../../ui/Title";
import type { BusinessPlanModel } from "../BusinessPlanModel";

export const BusinessGate = observer(
  ({ businessPlan }: { businessPlan: BusinessPlanModel }) => {
    const [email, setEmail] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);
    const [error, setError] = React.useState("");

    const { navigate } = useNavigation();
    const { t } = useTranslation();

    const confirmEmail = React.useCallback(async () => {
      setError("");
      setIsLoading(true);
      try {
        await businessPlan.joinWithEmail(email);

        if (!businessPlan.hasCompletedIntroduction) {
          navigate("BusinessIntro", {
            businessUid: businessPlan.uid,
          });
        } else {
          navigate("BusinessHome", {
            businessUid: businessPlan.uid,
          });
        }
      } catch {
        setError(t("business:gate_error_not_found"));
      }
      setIsLoading(false);
    }, [email, businessPlan, navigate, t]);

    return (
      <YStack gap={"$medium"}>
        <Box>
          <Title>{t("business:gate_welcome_title")}</Title>

          <Body>{t("business:gate_join_instructions")}</Body>

          {!!error && <Pill type={PillType.Danger}>{error}</Pill>}
          <Input
            placeholder={t("business:gate_email_placeholder")}
            autoComplete={"email"}
            keyboardType={"email-address"}
            inputMode={"email"}
            preventNewLine
            defaultValue={""}
            multiline={false}
            type="border"
            onChangeText={(text) => setEmail(text)}
            onSubmitEditing={confirmEmail}
          />

          <Button isLoading={isLoading} icon={Check} onPress={confirmEmail}>
            {t("business:gate_button_confirm")}
          </Button>

          <Body muted>{t("business:gate_confirmation_info")}</Body>
        </Box>
      </YStack>
    );
  },
);
